import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import AppLayout from "../layout/AppLayout";

export default function ClientesAdmin() {
  const [clientes, setClientes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/clientes_list.php")
      .then(res => setClientes(res.data))
      .catch(() => setClientes([]));
  }, []);

  return (
    <AppLayout title="Clientes">
      <div className="space-y-3">
        {clientes.map(c => (
          <div
            key={c.id}
            onClick={() => navigate(`/app/admin/clientes/${c.id}`)}
            className="cursor-pointer rounded-xl border border-[#1f2937] bg-[#121826] p-4 hover:bg-[#1a2233]"
          >
            <p className="text-sm font-semibold text-slate-100">{c.nome}</p>
            <p className="text-xs text-slate-400">
              {c.email} • {c.total_processos} processos
            </p>
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
